.monaco-mouse-cursor-text{cursor:text}